import { render, staticRenderFns } from "./DeactivateLicense.vue?vue&type=template&id=534f5949&lang=pug"
import script from "./DeactivateLicense.vue?vue&type=script&lang=js"
export * from "./DeactivateLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports